import React, { useEffect, useRef } from 'react';
import './techServicesSection.scss';
import { Link } from 'react-router-dom';
import iconoObjetibo from '../../../media/img/home/ObjetiboIcono.png';
import iconoCompromiso from '../../../media/img/home/CompromisoIcono.png';
import { FaFilm, FaFlask } from 'react-icons/fa';

const servicesData = [
  {
    id: 1,
    icon: <FaFilm size={50} color="#1e90ff" />,
    title: 'Producción Audiovisual',
    description:
      'Integramos neuropsicología en cada fase de la producción cinematográfica para optimizar guiones, personajes y dinámicas de equipo. #Neurocinema #IA',
    link: 'products',
  },
  {
    id: 2,
    icon: <FaFlask size={50} color="#1e90ff" />,
    title: 'Consultoría y Servicios',
    description:
      'Talleres, análisis predictivo del público y optimización de espacios creativos para productoras y equipos audiovisuales. #Neuropsicología #BI',
    link: 'services',
  },
];

const TechServicesSection = () => {
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);

      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div>
      <section className="section__services">
        <div className="services__header">
          <h1 className="content__title-backgroundDark">¿Qué hacemos?</h1>
          <div
            ref={(el) => (lineRefs.current[0] = el)}
            className="content__title-line"
          />
          <h2 className="content__text-title-backgroundDark">
            Aplicamos neuropsicología e inteligencia artificial a la producción
            audiovisual y las artes
          </h2>
        </div>
        <div className="services__grid">
          {servicesData.map((service) => (
            <Link
              to={`/productos/${service.link}`}
              className="service-card__flip-container"
              key={service.id}
            >
              <div className="service-card__flipper">
                <div className="service-card__front">
                  <div className="service-card__icon">{service.icon}</div>
                  <div className="service-card__content">
                    <h3 className="service-card__title">{service.title}</h3>
                    <p className="service-card__description">
                      {service.description}
                    </p>
                  </div>
                </div>
                <div className="service-card__back">
                  <p className="service-card__back-text">
                    Haz click para aprender más sobre {service.title}
                  </p>
                  <p className="service-card__back-arrow"> &#8594; </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="services__info-container">
          <div className="services__info-block">
            <div className="services__info-icon">
              <img src={iconoObjetibo} alt="Icono compromiso" />
            </div>
            <div className="services__info-content">
              <h3 className="services__info-title">Compromiso</h3>
              <p className="services__info-text">
                En WONDERALY INNOVATIONS, nuestro compromiso es claro: acercar
                la neuropsicología aplicada y la tecnología de vanguardia a la
                industria audiovisual para que cada producción alcance su máximo
                potencial creativo y emocional.
              </p>
            </div>
          </div>

          <div className="services__info-block">
            <div className="services__info-icon">
              <img src={iconoCompromiso} alt="Icono objetivos" />
            </div>
            <div className="services__info-content">
              <h3 className="services__info-title">Objetivos</h3>
              <p className="services__info-text">
                Nuestro principal objetivo es democratizar el acceso a la
                neuropsicología aplicada en la producción cinematográfica,
                proporcionando herramientas que no solo mejoren la calidad
                artística, sino que también impulsen la conexión emocional con
                el espectador. Aspiramos a convertirnos en el referente de
                innovación en la industria audiovisual.
              </p>
            </div>
          </div>

          <div className="services-info__block services-info__block--link">
            <a href="/productos/products" className="services-info__link">
              Conoce más de nuestro trabajo &#8594;
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechServicesSection;
